var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',{staticStyle:{"height":"120px","padding":"0"}},[_c('Header')],1),_c('el-container',[_c('el-aside',{attrs:{"width":"280px"}},[_c('SideBar')],1),_c('el-main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }